import { AgGridModule } from "@bfx/ag-grid-angular";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { CommonModule } from "@angular/common";
import { DataTableModule } from "@bfx/primeng/datatable";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "@bfx/primeng/inputtext";
import { NgModule } from "@angular/core";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { TabViewModule } from "@bfx/primeng/tabview";
import { TooltipModule } from "@bfx/primeng/tooltip";
import { TranslateModule } from "@ngx-translate/core";

import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";

import { BfxConnectionMonitorAuditComponent } from "./bfx-connection-monitor-audit.component";
import { BfxConnectionMonitorAuditService } from "./bfx-connection-monitor-audit.service";
import { BfxConnectionMonitorComponent } from "./bfx-connection-monitor.component";
import { BfxConnectionMonitorConnectionsComponent } from "./bfx-connection-monitor-connections.component";
import { BfxConnectionMonitorConnectionsService } from "./bfx-connection-monitor-connections.service";
import { BfxConnectionMonitorService } from "./bfx-connection-monitor.service";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    CommonModule,
    DataTableModule,
    BfxSharedModule,
    TranslateModule,
    TooltipModule,
    FormsModule,
    InputTextModule,
    CheckboxModule,
    NativeDesktopModule,
    TabViewModule,
    PerfectScrollbarModule,
    AgGridModule.withComponents([]),
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    BfxConnectionMonitorAuditService,
    BfxConnectionMonitorConnectionsService,
    BfxConnectionMonitorService,
  ],
  declarations: [
    BfxConnectionMonitorAuditComponent,
    BfxConnectionMonitorConnectionsComponent,
    BfxConnectionMonitorComponent,
  ],
  exports: [BfxConnectionMonitorComponent],
  bootstrap: [BfxConnectionMonitorComponent],
})
export class BfxConnectionMonitorModule {}
